import { mapState } from 'vuex'
import ClientMaterialGroupSettingEdit from '@/components/client/materialgroupsettings/edit/ClientMaterialGroupSettingEdit.vue'

export default {
  name: 'ClientMaterialGroupSettings',
  props: {
    clientApiId: String,
    settings: Array,
    loading: Boolean,
    showButton: {
      default: true,
      type: Boolean
    }
  },
  data () {
    return {
      selfLoading: false
    }
  },
  components: {
    ClientMaterialGroupSettingEdit
  },
  computed: {
    ...mapState(['config']),
    canEdit () {
      return this.ApiRequest.userHasPermission('edit-clients');
    },
    productSettings () {
      const materialGroups = this.$store.getters.getItemsFromConfigWithFilter('material_groups', 'deleted', false);
      const results = [];
      for (const id in materialGroups) {
        results.push({ material_group_id: id, from_date_period_id: null, to_date_period_id: null, value: 0, id: null, history: [], type_id: null, reportSubcode: null });
      }
      const self = this;
      let prevMaterialGroupId = null;
      this.settings.forEach(el => {
        const settingEl = results.find(curEl => (parseInt(curEl.material_group_id) === parseInt(el.material_group_id)));
        if (settingEl) {
          if (prevMaterialGroupId !== el.material_group_id) {
            if (el.to_date_period_id === null || el.to_date_period_id >= self.config.currentDatePeriod.id) {
              settingEl.id = el.id;
              settingEl.type_id = el.type_id;
              settingEl.from_date_period_id = el.from_date_period_id;
              settingEl.value = el.value;
              settingEl.to_date_period_id = el.to_date_period_id;
              settingEl.reportSubcode = el.reportSubcode;
            } else {
              settingEl.from_date_period_id = self.BasicHelper.getNextDatePeriod(el.to_date_period_id);
            }
            prevMaterialGroupId = el.material_group_id;
          }
          settingEl.history.push(el);
        }
      });
      return results;
    },
    tableHeaders () {
      const headers = [];
      headers.push({ key: 'material_group_id', label: this.$t('material-group.title'), format: 'formatFromConfig', configKey: 'material_groups', configParam: 'name' });
      headers.push({ key: 'reportSubcode', label: this.$t('report.title'), format: 'formatFunc', funcs: [this.getReportName], classFuncs: [] });
      headers.push({ key: 'from_date_period_id', label: this.$t('general.filters.date-period-from'), format: 'formatDatePeriod' });
      headers.push({ key: 'to_date_period_id', label: this.$t('general.filters.date-period-to'), format: 'formatDatePeriod' });
      headers.push({ key: 'value', label: this.$t('material-group.discount'), format: 'formatPercent' });
      if (this.canEdit) {
        const actions = [
          { label: this.$t('menu.clients.materialgroupsetting.edit'), emit: 'editItem', icon: 'edit', bicon: 'pencil-fill', ifconfig: { param: 'id', value: null, notCheck: true } },
          { label: this.$t('menu.clients.materialgroupsetting.delete'), emit: 'deleteItem', icon: 'delete', bicon: 'trash', ifconfig: { param: 'id', value: null, notCheck: true } },
          { label: this.$t('menu.clients.materialgroupsetting.new'), emit: 'addItem', icon: 'add', bicon: 'plus' }
        ];
        headers.push({ key: 'actions', label: '', actions: actions });
      }
      return headers;
    },
    tableExpandConfig () {
      return { component: 'ClientMaterialGroupSettingExpand' };
    },
    reportOptions () {
      return this.ZPFormatHelper.getReportNameOptions(false, false);
    }
  },
  methods: {
    showDiscountList () {
      this.$refs['modal-list'].show();
    },
    editItem (item) {
      this.$refs.editElFrm.show(item);
    },
    addItem (item) {
      const elData = this.BasicHelper.cloneObject(item);
      elData.id = null;
      this.editItem(elData);
    },
    deleteItem (item, approved) {
      if (approved) {
        const self = this;
        self.selfLoading = true;
        this.ApiRequest.request('client/single/' + this.clientApiId + '/material-settings/delete', this.ApiRequest.REQUEST_POST, { id: item.id }, function (response) {
          if (response.error) {
            self.ApiRequest.displayErrorDialog(response, self);
          } else {
            self.$emit('saved', response.data);
          }
          self.selfLoading = false;
        });
      } else {
        this.$refs.itemDeleteMsgBox.show(
          item,
          this.$t('menu.clients.materialgroupsetting.deleteTitle'),
          this.$t('menu.clients.materialgroupsetting.deleteMessage')
        );
      }
    },
    getReportName (val) {
      const el = this.reportOptions.find(el => el.reportSubcode == val);
      if (el) {
        return el.text;
      }
      return '';
    }
  }
}
